import React, { useState } from 'react';
import { Menu, X, MessageCircle } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    { title: 'Sobre o Método', href: '#about' },
    { title: 'Adaptações', href: '#adaptations' },
    { title: 'Depoimentos', href: '#testimonials' },
    { title: 'Mentorias e Planos', href: '#plans' },
    { title: 'Fale Conosco', href: '#contact' },
  ];

  return (
    <header className="fixed top-0 w-full bg-white shadow-md z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <a href="#" className="flex items-center">
              <img 
                src="https://imgur.com/11veOBu.png" 
                alt="Professora Isabelle Reis" 
                className="h-16 w-auto"
              />
              <div className="ml-2">
                <h1 className="text-xl font-bold text-primary">PDTE</h1>
                <p className="text-xs text-primary/70">Redação para Transformação</p>
              </div>
            </a>
          </div>

          <nav className="hidden md:flex space-x-8">
            {menuItems.map((item) => (
              <a
                key={item.title}
                href={item.href}
                className="text-primary/80 hover:text-accent transition-colors"
              >
                {item.title}
              </a>
            ))}
          </nav>

          <a
            href="https://app.my-whats.com/0ebd27efd9"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:flex items-center px-4 py-2 bg-accent text-white rounded-full hover:bg-accent-dark transition-colors"
          >
            <MessageCircle className="h-4 w-4 mr-2" />
            Fale com nossa equipe
          </a>

          <button
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <X className="h-6 w-6 text-primary" />
            ) : (
              <Menu className="h-6 w-6 text-primary" />
            )}
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {menuItems.map((item) => (
                <a
                  key={item.title}
                  href={item.href}
                  className="block px-3 py-2 text-base font-medium text-primary/80 hover:text-accent hover:bg-gray-50 rounded-md"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.title}
                </a>
              ))}
              <a
                href="https://app.my-whats.com/0ebd27efd9"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center px-3 py-2 text-base font-medium text-white bg-accent rounded-md"
              >
                <MessageCircle className="h-4 w-4 mr-2" />
                Fale com nossa equipe
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;